import React, { useState } from 'react'


const SearchBar = ({ onFormSubmit }) => {
    const [term, setTerm] = useState('')

    const onSubmit = (e) => {
        e.preventDefault()
        // To do make sure we call calback from componnent
        onFormSubmit(term)
    }

    return (
        <div className='ui segment search-bar' style={{ marginTop: '10px' }}>
            <form onSubmit={onSubmit} className="ui form">
                <div className="field">
                    <label>Video Search</label>
                    <input
                        type="text"
                        value={term}
                        onChange={(e) => setTerm(e.target.value)} />
                </div>
            </form>
        </div>
    )
};




export default SearchBar
